import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=44b0589e&scoped=true&"
import script from "./ErrorIcon.vue?vue&type=script&lang=js&"
export * from "./ErrorIcon.vue?vue&type=script&lang=js&"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=44b0589e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b0589e",
  null
  
)

export default component.exports